import { RequestStructuresByGroup } from "../dtos/structure";
import Server from "./index";

export default class StructureServer extends Server {
  constructor() {
    super("/structure.php");
  }

  public get(params: RequestStructuresByGroup): Promise<any> {
    return super.get(params);
  }
}
